export const ERROR_BODY_PORTABLE_TEXT = [
  {
    _type: 'block',
    children: [
      {
        _type: 'span',
        marks: [],
        text: 'We apologize, but our servers are currently experiencing issues. Please try again later.',
      },
    ],
    markDefs: [],
    style: 'normal',
  },
]

export const SUCCESS_SNACKBAR_BODY =
  'Your inquiry has been received and a team member will be in contact within 5 business days. We appreciate your interest in our spaces and look forward to helping you.'

export const SUCCESS_SNACKBAR_BODY_GATED_EMAIL =
  'Your inquiry has been received. Check your email for the download link—we have sent the content to the address you provided.'
